import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DASHBOARD, COMPANY, PROJECT, TIMELAPSE, LIVECAM, IMAGECOUNT } from "../../services/actions";
import { BsFillTagFill } from "react-icons/bs";
import Analytics from "./Analytics";
import { CircularProgress } from "./CircularProgress";
import ViewList from "../extra/ViewList";
// import Map from "../extra/Map";
import {
  Badge,
  Card,
  Box,
  Button,
  Typography,
  Container,
  Grid,
  Chip,
} from "@mui/material";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardState = useSelector((state) => state?.dashboardState);
  const imagecountState = useSelector((state) => state?.imagecountState);
  const projectState = useSelector((state) => state?.projectState);
  const user = useSelector((state) => state?.loginState?.auth);

  // React.useEffect(() => {
  //   dispatch({ type: `${DASHBOARD}_GET`, payload: 0 });
  //   dispatch({ type: `${PROJECT}_GET`, payload: 0 });
  //   dispatch({ type: `${IMAGECOUNT}_GET`, payload: 0 });
  // }, []);

  const toLocalTime = (utcDateString) => {
    return new Date(utcDateString).toLocaleString();
  };

  const timelaspeData = () => {
    let out = { S: { value: 30 }, M: { value: 60 }, T: { value: 70 }, W: {}, TH: { value: 20 }, F: {}, ST: { value: 80 } }
    console.log("IMAGE COUNT:", imagecountState)
  }

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Typography sx={{ pt: 2 }} fontSize={11} fontWeight={600}>
            G'day, {user.first_name} - <Chip fontSize={8} size="small" label={user.main_role} />
          </Typography>
        </Grid>
      </Grid>

      {/* Cards with dashboard data */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {(dashboardState?.data?.results || []).map((data, i) => {
          const isPrimary = i === 0;
          return (
            <Grid size={{ xs: 12, md: 3 }} key={i}>
              <Card
                sx={{
                  width: 1,
                  p: 3,
                  pt: 3.5,
                  pb: 4,
                  borderRadius: 8,
                  boxShadow: 0,
                  ...(isPrimary && {
                    background: "linear-gradient(to bottom, #195539, #307248)",
                    color: "white",
                  }),
                }}
              >
                <Typography variant="h6">{data.name}</Typography>
                <Typography variant="h4" sx={{ mt: 2 }}>
                  {data.count}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Analytics, Reminder, Map */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Analytics title="Timelapse Analysis" data={timelaspeData()} />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 3,
              pt: 3.5,
              pb: 4,
              borderRadius: 8,
              boxShadow: 0,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Reminders
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Meeting with Arc Company
            </Typography>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(to bottom, #195539, #307248)",
                color: "white",
              }}
            >
              Start Meeting
            </Button>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 2,
              borderRadius: 8,
              boxShadow: 0,
              height: 250,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Location
            </Typography>
            {/* <Map height="180px" /> */}
          </Card>
        </Grid>
      </Grid>

      {/* Project Analysis + Progress */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Analytics title="Project Analysis" />
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 3,
              pt: 3.5,
              pb: 4,
              borderRadius: 8,
              boxShadow: 0,
              textAlign: "center",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Project Progress
            </Typography>
            <CircularProgress />
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 1 }}>
              <Box sx={{ fontSize: 10 }}>Progress</Box>
              <Box sx={{ fontSize: 10 }}>Completed</Box>
              <Box sx={{ fontSize: 10 }}>Pending</Box>
            </Box>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }}>
          <Card
            sx={{
              p: 3,
              pt: 3.5,
              pb: 4,
              borderRadius: 8,
              boxShadow: 0,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Projects
            </Typography>
            <ViewList list={(projectState?.data?.results || [])} keyname="project_name" />
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
